import React, { useEffect, useState } from "react";
import { resolveStorageReference } from "../lib/storageReferences";

export default function StorageFileLink({ reference, children, onClick, ...props }) {
  const [href, setHref] = useState("");

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      const nextHref = await resolveStorageReference(reference);
      if (isMounted) {
        setHref(nextHref || "");
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [reference]);

  return (
    <a
      {...props}
      href={href || "#"}
      onClick={(event) => {
        if (!href) {
          event.preventDefault();
        }

        onClick?.(event);
      }}
      aria-disabled={!href}
    >
      {children}
    </a>
  );
}